import { createAPIModule } from 'utility/redux/apiModuleHelpers';

const getStateSlice = (state) => state.api.server.vncConsole;

const { actions, reducer, sagas, selectors } = createAPIModule({
	getStateSlice,
	actionType: 'SERVER_VNCCONSOLE',
	url: '/server/vncConsole.json',
});

export { actions, reducer, sagas, selectors };
